export default "__VITE_ASSET__DILOc0ok__"